<script setup lang="ts">
import { vMaska } from "maska";
import { useFiltrosStore } from '@/stores/filtros';
useFiltrosStore();
</script>
<style scoped>
.hr-bottom {
    border-bottom: 1px solid #ced4da;
}

.form-control {
    padding-left: 0;
}

label,
input[type=text],
input[type=date] {
    font-size: 0.8em;
}

.form-check-input:checked {
    background-color: #f58634;
    border-color: #f58634;
}

.form-check-input {
    --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e");
    background-color: #fff;
    border-color: #ced4da;
    box-shadow: none
}

.btn btn-secondary {
    border-radius: none;
    width: 150px;
}
</style>
<template>
    <div id="filtro-obras-componente">
        <div class="row g-0">
            <div class="col-12 mb-3">
                <input type="text" v-maska data-mask="'##/###.###/####'" v-model="filtro.numeroProcesso"
                    class="form-control" id="txtProcesso" placeholder="Nº PROCESSO" />
            </div>
            <div class="col-12 mb-3">
                <input type="text" v-model="filtro.descricao" class="form-control" id="txtDescricao" maxlength="250"
                    placeholder="DESCRIÇÃO LOTE" />
            </div>
        </div>
        <div class="row g-0 mb-3">
            <div class="col-12 mb-2">
                <label class="form-label" for="txtDataInicialAssinaturaContrato">DATA INICIAL DA ASSINATURA</label>
                <input type="date" v-model="filtro.dataInicialAssinaturaContrato" class="form-control"
                    id="txtDataInicialAssinaturaContrato" />
            </div>
            <div class="col-12">
                <label class="form-label" for="txtDataFinalAssinaturaContrato">DATA FINAL DA ASSINATURA</label>
                <input type="date" v-model="filtro.dataFinalAssinaturaContrato" class="form-control"
                    id="txtDataFinalAssinaturaContrato" />
            </div>
        </div>
        <div class="row g-0 hr-bottom mb-3">
            <div class="col-4">
                <multiselect :searchable="false" v-model="filtro.uf" :options="listaUFs" label="descricao" track-by="id"
                    selectedLabel="" deselectLabel="" selectLabel="" placeholder="UF">
                </multiselect>
            </div>
            <div class="col-8">
                <multiselect :searchable="false" v-model="filtro.municipios" :options="listaMunicipios" label="descricao"
                    track-by="id" multiple selectLabel="" selectedLabel="" deselectLabel="" no-options="Selecione uma UF"
                    placeholder="MUNICÍPIO">MUNICÍPIO
                </multiselect>
            </div>
        </div>
        <div class="row g-0">
            <div class="col-12 mb-3">
                <input type="text" class="form-control" v-model="filtro.endereco" maxlength="250" placeholder="ENDEREÇO" />
            </div>
        </div>
        <div class="row g-0 hr-bottom mb-3">
            <div class="col-12">
                <div class="form-inline">
                    <multiselect :searchable="false" v-model="filtro.departamentos" :options="listaDepartamentos"
                        label="descricao" track-by="id" multiple selectLabel="" selectedLabel="" deselectLabel=""
                        placeholder="DEPARTAMENTO">
                    </multiselect>
                </div>
            </div>
        </div>
        <div class="row g-0 hr-bottom mb-3">
            <div class="col-12">
                <div class="form-check form-check-inline" v-for="(situacao, index) in listaSituacoesLote" :key="index">
                    <input type="checkbox" name="situacaoLote" class="form-check-input" checked required :value="situacao"
                        v-model="situacoesLote">
                    <label class="form-check-label" for="credit">{{ situacao.descricao }}</label>
                </div>
            </div>
        </div>
        <div class="row g-0 hr-bottom mb-3">
            <div class="col-12 mb-3">
                <label class="form-label">CLASSIFICAÇÃO DA OBRA</label>
            </div>
            <div class="col-12">
                <div class="form-check form-check-inline" v-for="(tipoObjeto, index) in listaTiposObjeto" :key="index">
                    <input type="checkbox" name="tipoObjeto" class="form-check-input" checked required
                        :value="tipoObjeto.id" v-model="filtro.listaTipoObjeto">
                    <label class="form-check-label" for="situacaoLote">{{ tipoObjeto.descricao }}</label>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="col-12 mb-3">
                <input type="text" class="form-control" maxlength="20" placeholder="CÓDIGO DO LOTE" v-maska
                    data-mask="'##########'" v-model="filtro.codLote" />
            </div>
        </div>
        <div class="row g-0 py-2 hr-bottom mb-3">
            <div class="col-12">
                <div class="form-check form-switch ps-0 pe-2">
                    <label class="form-check-label float-start" for="somenteGeolocalizados">SOMENTE
                        GEOLOCALIZADOS</label>
                    <input class="form-check-input float-end" type="checkbox" role="switch" id="somenteGeolocalizados"
                        v-model="filtro.geoLocalizados">
                </div>
            </div>
        </div>
        <div class="row g-0 py-2 hr-bottom mb-3">
            <div class="col-12">
                <div class="form-check form-switch ps-0 pe-2">
                    <label class="form-check-label float-start" for="somenteAtivos">SOMENTE ATIVOS</label>
                    <input class="form-check-input float-end" type="checkbox" role="switch" id="somenteAtivos"
                        v-model="filtro.ativos">
                </div>
            </div>
        </div>
        <div class="row g-0 hr-bottom mb-3">
            <div class="col-12 mb-3">
                <label class="form-label">
                    UNIDADE EXECUTORA
                </label>
            </div>
            <div class="col-12">
                <div class="form-check form-check-inline">
                    <input type="radio" name="classificacaoProjeto" class="form-check-input" :value="null"
                        v-model="filtro.classificacaoProjeto">
                    <label class="form-check-label" for="classificacaoProjeto">Todos</label>
                </div>
                <div class="form-check form-check-inline">
                    <input type="radio" name="classificacaoProjeto" class="form-check-input" :value="0"
                        v-model="filtro.classificacaoProjeto">
                    <label class="form-check-label" for="classificacaoProjeto">Execução Própria</label>
                </div>
                <div class="form-check form-check-inline">
                    <input type="radio" name="classificacaoProjeto" class="form-check-input" :value="1"
                        v-model="filtro.classificacaoProjeto">
                    <label class="form-check-label" for="classificacaoProjeto" value="1">Outros: Convênio</label>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">

import Multiselect from 'vue-multiselect';
import { defineComponent, toRaw } from 'vue';
import Filtros from "@/services/model/filtros";
import type Item from '@/services/model/item';
import type FiltroPadrao from '@/services/model/filtroPadrao';
import municipioService from '@/services/municipio.service';
import ufService from '@/services/uf.service';
import configService from '@/services/config.service';
import loteService from '@/services/lote.service';
import ItemArvore from '@/services/model/itemArvore';
import { mapStores } from "pinia";


class SituacaoStore {
    licitacao = new Array<Item>();
    contrato = new Array<Item>();
}

class FiltrosObrasModel {
    filtroPadrao: FiltroPadrao | null = null;
    listaUFs: Array<Item> = new Array<Item>();
    listaMunicipios: Array<Item> = new Array<Item>();
    listaDepartamentos: Array<Item> = new Array<Item>();
    listaSituacoesLote: Array<Item> = new Array<Item>();
    listaSituacoesLicitacao: Array<Item> = new Array<Item>();
    listaSituacoesContrato: Array<Item> = new Array<Item>();
    listaSituacoesStore = new SituacaoStore();
    situacoesLote: Array<Item> = new Array<Item>();
    listaTiposObjeto = new Array<ItemArvore>();
    consultandoObras = false;
    suspensoSelecionado = false;
    filtro = new Filtros();
}

export default defineComponent({
    components: { Multiselect },
    name: 'FiltrosObras',
    data() {
        return new FiltrosObrasModel();
    },
    props: {
        limpar: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        ...mapStores(useFiltrosStore),
    },
    async mounted() {
        this.carregarLocalStorage();

        this.$watch('filtro', (newValue: Filtros, oldValue: Filtros) => {
            this.FiltrosStore.update(newValue);
        }, { deep: true });

        this.$watch('listaUFs', () => {
            this.carregarPesquisaPadrao();
        });

        this.$watch('listaMunicipios', () => {
            if (this.filtroPadrao != null && this.filtroPadrao.municipio != null) {
                const municipioPadrao = this.listaMunicipios.find(m => m.descricao == this.filtroPadrao?.municipio);
                if (municipioPadrao != null) {
                    this.filtro.municipios.push(municipioPadrao);
                }
            }
        });

        this.$watch('filtroPadrao', () => {
            if (this.filtroPadrao != null && this.filtroPadrao.estado != null) {
                let uf = this.listaUFs.find(uf => uf.descricao == this.filtroPadrao?.estado);
                if (uf != null)
                    this.filtro.uf = uf;
            }
        });

        this.$watch('filtro.uf', () => {
            this.filtro.municipios = [];
            this.carregarMunicipios();
        });

        this.$watch('filtro.ativos', () => {
            if (this.filtro.ativos) {
                this.situacoesLote = this.situacoesLote.filter(sit => sit.id != 8);
            }
        });

        this.$watch('situacoesLote', () => {
            this.filtro.situacoesLote = this.situacoesLote;
            if (this.filtro.situacoesLote.find(sit => sit.id == 8)) {
                this.filtro.ativos = false;
                this.suspensoSelecionado = true;
            } else if (this.suspensoSelecionado) {
                this.suspensoSelecionado = false;
                this.filtro.ativos = true;
            }
            if (this.filtro.situacoesLote.length == 1) {
                if (this.filtro.situacoesLote[0].id == 4) //licitando
                    this.listaSituacoesLicitacao = this.listaSituacoesStore.licitacao.filter(function (situacaoLicitacao) {
                        return (situacaoLicitacao.id >= 0 && situacaoLicitacao.id <= 10) || situacaoLicitacao.id == 50;//de iniciada ate apuracao do julgamento, ou em apuracao
                    }).sort(function (prev, next) { return prev.id - next.id; });
                if (this.filtro.situacoesLote[0].id == 5) //licitado
                    this.listaSituacoesLicitacao = this.listaSituacoesStore.licitacao.filter(function (situacaoLicitacao) {
                        return (situacaoLicitacao.id >= 11 && situacaoLicitacao.id <= 24); //de concluida ate concluida/deserta
                    }).sort(function (prev, next) { return prev.id - next.id; });
            }
            else
                this.listaSituacoesLicitacao = [];

            if (this.filtro.situacoesLote.length == 1) {
                if (this.filtro.situacoesLote[0].id == 6) //contratado
                    this.listaSituacoesContrato = this.listaSituacoesStore.contrato.filter(function (situacaoContrato) {
                        return (situacaoContrato.id >= 0 && situacaoContrato.id <= 3 && situacaoContrato.id != 2) || situacaoContrato.id == 10;//de ativo ate paralisado, ou em aberto
                    }).sort(function (prev, next) { return prev.id - next.id; });
                if (this.filtro.situacoesLote[0].id == 7) //concluído
                    this.listaSituacoesContrato = this.listaSituacoesStore.contrato.filter(function (situacaoContrato) {
                        return (situacaoContrato.id >= 4 && situacaoContrato.id <= 9) || situacaoContrato.id == 2; //de executado ate expirado
                    }).sort(function (prev, next) { return prev.id - next.id; });
            }
            else
                this.listaSituacoesContrato = [];
        });

        this.$watch(
            'limpar', () => {
                this.filtro = new Filtros();
                this.filtroPadrao = null;
                this.listaUFs = new Array<Item>();
                this.listaMunicipios = new Array<Item>();
                this.listaDepartamentos = new Array<Item>();
                this.listaSituacoesLote = new Array<Item>();
                this.listaSituacoesLicitacao = new Array<Item>();
                this.listaSituacoesContrato = new Array<Item>();
                this.listaSituacoesStore = new SituacaoStore();
                this.situacoesLote = new Array<Item>();
                this.listaTiposObjeto = new Array<ItemArvore>();
                this.consultandoObras = false;
                this.suspensoSelecionado = false;
                this.carregar();
            },
        );

        await this.carregar();

    },
    unmounted() {
        this.salvarLocalStorage();
    },
    methods: {
        carregarLocalStorage(): boolean {
            const persistedDataString = window.localStorage.getItem('FiltrosObrasModel');
            if (persistedDataString != null) {
                const persistedData = JSON.parse(persistedDataString);
                this.filtroPadrao = persistedData.filtroPadrao;
                this.listaUFs = persistedData.listaUFs;
                this.listaMunicipios = persistedData.listaMunicipios;
                this.listaDepartamentos = persistedData.listaDepartamentos;
                this.listaSituacoesLote = persistedData.listaSituacoesLote;
                this.listaSituacoesLicitacao = persistedData.listaSituacoesLicitacao;
                this.listaSituacoesContrato = persistedData.listaSituacoesContrato;
                this.listaSituacoesStore = persistedData.listaSituacoesStore;
                this.situacoesLote = persistedData.situacoesLote;
                this.listaTiposObjeto = persistedData.listaTiposObjeto;
                this.consultandoObras = persistedData.consultandoObras;
                this.suspensoSelecionado = persistedData.suspensoSelecionado;
                this.filtro = persistedData.filtro;
                return true;
            }
            return false;
        },
        async carregar() {
            await this.carregarUFs();
            await this.carregarDepartamentos();
            await this.carregarSituacoes();
            await this.carregarTiposObjetos();
        },
        async carregarUFs() {
            if (this.listaUFs.length == 0) {
                this.listaUFs = (await ufService.obterUfs()).data;
            }

        },
        async carregarMunicipios() {
            if (this.filtro.uf != null && this.filtro.uf.id > 0) {
                this.listaMunicipios = (await municipioService.obterMunicipios(this.filtro.uf.id)).data;
            }
            else {
                this.listaMunicipios = [];
            }
        },
        async carregarDepartamentos() {
            if (this.listaDepartamentos.length == 0) {
                this.listaDepartamentos = (await configService.carregarDepartamentos()).data;
            }

        },
        async carregarPesquisaPadrao() {
            this.filtroPadrao = (await configService.carregarFiltroPadrao()).data;
        },
        async carregarSituacoes() {
            if (this.listaSituacoesLote.length == 0) {
                this.listaSituacoesLote = (await loteService.obterSituacoesLote()).data;
                this.listaSituacoesStore.licitacao = (await loteService.obterSituacoesLicitacao()).data;
                this.listaSituacoesStore.contrato = (await loteService.obterSituacoesContrato()).data;

				const contratado = this.listaSituacoesLote.find(s => s.id === 6);
				if (contratado) {
					this.situacoesLote = [contratado];
				}
            }
        },
        async carregarTiposObjetos() {
            if (this.listaTiposObjeto.length == 0) {
                this.listaTiposObjeto = (await loteService.obterTiposObjetos()).data;
            }

        },
        async salvarLocalStorage() {
            window.localStorage.setItem('FiltrosObrasModel', JSON.stringify(toRaw(this.$data)));
        },
    }
})
</script>
